module.exports = __webpack_public_path__ + "static/media/logo-white.9cf5fbef.svg";